import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22a1d831")

_pushScopeId("data-v-22a1d831")
const _hoisted_1 = {
  key: 0,
  class: "py-4 w-12 flex flex-col"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-full mb-1 text-xs hidden lg:flex justify-center text-gray-500" }, " 全選択 ", -1)
const _hoisted_3 = {
  key: 1,
  class: "w-14"
}
const _hoisted_4 = {
  key: 0,
  class: "w-12"
}
const _hoisted_5 = {
  key: 1,
  class: "w-31"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "w-12" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_table_header_cell = _resolveComponent("m-table-header-cell")

  return (_openBlock(), _createBlock("div", {
    class: ["w-full flex sticky z-10 min-h table-header-bg", `-top${-12 + _ctx.paddingTop === 0 ? '-0' : -12 + _ctx.paddingTop}`]
  }, [
    _createVNode("div", {
      class: [
        'flex',
        'items-center',
        _ctx.hasPinnedColumn ? 'sticky-container' : ''
      ]
    }, [
      (_ctx.selectable)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("label", {
              for: "select-all",
              class: "w-full px-4 hidden lg:flex text-gray-400",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createVNode("input", {
                id: "select-all",
                type: "checkbox",
                name: "select",
                checked: _ctx.selectedAll,
                class: "cursor-pointer",
                disabled: _ctx.disableSelection ?? false,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args)))
              }, null, 40, ["checked", "disabled"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.order)
        ? (_openBlock(), _createBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedDatas.pinnedDatas, (data) => {
        return (_openBlock(), _createBlock(_component_m_table_header_cell, {
          key: data.key,
          text: data.text,
          size: data.size,
          "max-size": data.maxSize,
          sortable: data.sortable,
          select: data.select,
          desc: data.desc,
          "show-on-mobile": data.showOnMobile,
          class: "lg:flex",
          onClick: ($event: any) => (_ctx.change(data))
        }, null, 8, ["text", "size", "max-size", "sortable", "select", "desc", "show-on-mobile", "onClick"]))
      }), 128))
    ], 2),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedDatas.scrollableDatas, (data) => {
      return (_openBlock(), _createBlock(_component_m_table_header_cell, {
        key: data.key,
        text: data.text,
        size: data.size,
        "max-size": data.maxSize,
        sortable: data.sortable,
        select: data.select,
        desc: data.desc,
        "show-on-mobile": data.showOnMobile,
        class: "lg:flex",
        onClick: ($event: any) => (_ctx.change(data))
      }, null, 8, ["text", "size", "max-size", "sortable", "select", "desc", "show-on-mobile", "onClick"]))
    }), 128)),
    (_ctx.hasLink && _ctx.editable)
      ? (_openBlock(), _createBlock("div", _hoisted_4))
      : (_ctx.useActions)
        ? (_openBlock(), _createBlock("div", _hoisted_5))
        : (_ctx.useSubmission)
          ? (_openBlock(), _createBlock(_component_m_table_header_cell, {
              key: 2,
              text: "提出物",
              size: 20,
              sortable: false,
              select: false,
              class: "lg:flex"
            }))
          : _createCommentVNode("", true),
    _hoisted_6
  ], 2))
})